export const GIFT_CARD_TARGETS = {
  FORM_DATA: 'formData',
  GIFT_CARD_SECTION_OPENED: 'giftCardSectionOpened'
};
